import { ChatCreateGroup } from './ChatCreateGroup'
import { ChatCreateGroupContextProvider } from './ChatCreateGroup/ChatCreateGroupContext'

export const EditGroupChatWrapper = () => (
  <ChatCreateGroupContextProvider initialState={{ variant: 'edit' }}>
    <ChatCreateGroup />
  </ChatCreateGroupContextProvider>
)
